import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { SpinProps } from 'antd/lib/spin';

interface LoadingProps extends Partial<Omit<SpinProps, 'size'>> {
  size?: number;
  icon?: JSX.Element;
  children?: React.ReactNode;
}

const Loading = ({ size = 24, icon, ...restProps }: LoadingProps) => {
  const antIcon = icon || <LoadingOutlined style={{ fontSize: size }} spin />;
  return <Spin indicator={antIcon} {...restProps} />;
};

export default Loading;
